import { EventNoteOutlined } from '@material-ui/icons'
import { useDialogManager } from 'features/DialogManager/DialogManager'
import { BoMItemType } from 'model/Project/BoMItemRow'
import { BadgeList } from './BadgeList'
import { BomItemMenuItem } from './BomItemMenuItem'

export const EventLogMenuItem = ({
  bomItemId,
  bomItemType,
  onClose,
}: {
  bomItemId: string
  bomItemType: BoMItemType
  onClose: () => void
}) => {
  const { openDialog } = useDialogManager()

  const handleOpen = () => {
    openDialog('EventLogs', {
      bomItemId: bomItemId,
      bomItemType: bomItemType,
    })
  }

  return (
    <BomItemMenuItem
      onClick={handleOpen}
      closeOnClick
      onClose={onClose}
      primaryTextTranslationKey="project:event-logs"
      secondary={<BadgeList bomItemId={bomItemId} />}
      icon={<EventNoteOutlined />}
      hiddenForBuyers
    />
  )
}
